import React, { useRef } from 'react';
import { useEditcomplainAppMutation, useGetcompalinAdminStatusQuery } from './complainAdminListSlice';
import { useGetWardsQuery } from '../Cleaner/CleanerSlice';

function ComplainAdminAction({ refOpen, editData, setEditData }) {
    const refCloseDriver = useRef(null);
    const [editcomplain, { isLoading }] = useEditcomplainAppMutation();

    const {
        data: CompalinAdminStatus,
        isStatusListError,
        isStatusListLoading,
    } = useGetcompalinAdminStatusQuery();

    const {
        data: Wards
    } = useGetWardsQuery("getWards");

    const handleChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const handleClick = async (e) => {
        e.preventDefault();
        console.log("editData", editData);

        try {
            const response = await editcomplain({
                id: editData?.id,
                u_name: editData?.u_name,
                u_number: editData?.u_number,
                prp_name: editData?.prp_name,
                address: editData?.address,
                ward_id: editData?.ward_id,
                complain_text: editData?.complain_text,
                status: editData?.status,
                remark: editData?.remark
            });
            refCloseDriver.current.click();
            setEditData({ name: "", number: "", ward_id_array: "" });
            console.log("response", response);

        } catch (e) {
            console.error("Error in cleaner edit", e);
        }
    };
    return (
        <>
            <button
                ref={refOpen}
                type="button"
                className="btn d-none"
                data-bs-toggle="offcanvas"
                data-bs-target="#depOffCanvas1"
                aria-controls="depOffCanvas1"
            ></button>

            <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="true"
                data-bs-backdrop="false"
                tabIndex="-1"
                id="depOffCanvas1"
                aria-labelledby="depOffCanvas1"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Edit Cleaner</h5>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        ref={refCloseDriver}
                    ></button>
                </div>

                <div className="offcanvas-body">
                    <form className="row g-3">
                        <div className="col-md-12 text-left">
                            <label htmlFor="name" className="form-label font-weight-bold">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="u_name"
                                name="u_name"
                                value={editData?.u_name}
                                onChange={handleChange}
                                placeholder="Name"
                                autoComplete="off"
                                required
                            />
                        </div>

                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Number</label>
                            <input
                                type="text"
                                className="form-control"
                                id="u_number"
                                name="u_number"
                                value={editData?.u_number}
                                onChange={handleChange}
                                placeholder="Number"
                                autoComplete="off"
                                required
                            />
                        </div>
                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Property Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="prp_name"
                                name="prp_name"
                                value={editData?.prp_name}
                                onChange={handleChange}
                                placeholder="Property Name"
                                autoComplete="off"
                                required
                            />
                        </div>
                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Address</label>
                            <input
                                type="text"
                                className="form-control"
                                id="address"
                                name="address"
                                value={editData?.address}
                                onChange={handleChange}
                                placeholder="Address"
                                autoComplete="off"
                                required
                            />
                        </div>
                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Ward</label>
                            <select
                                className="form-select mb-5"
                                aria-label="complain status"
                                id="ward_id"
                                name="ward_id"
                                value={editData?.ward_id}
                                onChange={handleChange}
                            >
                                <option selected>--</option>
                                {!isStatusListLoading && !isStatusListError && Wards?.ids?.map(item => {
                                    return <option value={Wards?.entities[item]}>{Wards?.entities[item]?.ward_number}</option>
                                })}
                            </select>
                        </div>
                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Complain</label>
                            <input
                                type="text"
                                className="form-control"
                                id="complain_text"
                                name="complain_text"
                                value={editData?.complain_text}
                                onChange={handleChange}
                                placeholder="Complain"
                                autoComplete="off"
                                required
                            />
                        </div>
                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Status</label>
                            <select
                                className="form-select mb-5"
                                aria-label="complain status"
                                id="status"
                                name="status"
                                value={editData?.status}
                                onChange={handleChange}
                            >
                                <option selected>--</option>
                                {!isStatusListLoading && !isStatusListError && CompalinAdminStatus?.map(item => {
                                    return <option value={item}>{item}</option>
                                })
                                }
                            </select>
                        </div>
                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Remark</label>
                            <input
                                type="text"
                                className="form-control"
                                id="remark"
                                name="remark"
                                value={editData?.remark}
                                onChange={handleChange}
                                placeholder="Remark"
                                autoComplete="off"
                                required
                            />
                        </div>

                        <div className="col-md-12">
                            <button
                                type="submit"
                                className="btn btn-ff9b44 btn-block btn-round"
                                onClick={handleClick}
                            >
                                {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default ComplainAdminAction;
